module.exports = __webpack_public_path__ + "img/slide-img-2.33cf3e76.png";